var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.247,
    height: 16.095,
    viewBox: "0 0 15.247 16.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-a{fill:#191818;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow-a",
    d: "M0,5.768l.288,4.558c2.8-.192,5.386-.222,8.084-.2C7.3,11.447,6.205,12.738,5.128,14.05c1.49.681,3.041,1.3,4.468,2.045a43.073,43.073,0,0,1,3.014-4.522l2.637-3.553s-2.371-3.4-2.422-3.5c-.446-.736-.914-1.5-1.346-2.261A13.288,13.288,0,0,0,10.134,0c-1.416.612-2.8,1.259-4.306,1.777.987,1.389,2.044,2.708,3.024,4.1C5.858,5.89,3.112,5.806,0,5.768"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.58f9032df517c080ae9135aa3378c58f.svg";
export { ForwardRef as ReactComponent };